<template>
    <painel-component :itens="itensOne">
        <row-component>
            <row-col-component
                    :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                <input v-model="formData.client_employee_provider_type" type="radio"
                       name="docs" id="cliente"
                       :value='parseInt("1")'>
                <label for="cliente">Cliente</label>

                <input v-model="formData.client_employee_provider_type" type="radio"
                       name="docs" id="fornecedor"
                       :value='parseInt("3")'>
                <label for="fornecedor">Fornecedor</label>

                <input checked v-model="formData.client_employee_provider_type" type="radio"
                       name="docs"
                       id="funcionario"
                       :value='parseInt("2")'>
                <label for="funcionario">Funcionário</label>
            </row-col-component>
        </row-component>

        <row-component>
            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Código:</label>
                <input-component :type-input="'text'" v-model="formData.code"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                <label>Titulo:</label>
                <input-component :type-input="'text'" v-model="formData.title"/>
            </row-col-component>

            <row-col-component v-if="formData.client_employee_provider_type === 2"
                               :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Funcionário:</label>
                <Multiselect label="name" v-model="formData.client_employee_provider_id" :options="selectEmployeeList"
                             :searchable="true"
                             :noOptionsText="noOptionsText"
                             :noResultsText="noResultsText"/>
            </row-col-component>

            <row-col-component v-else-if="formData.client_employee_provider_type === 3"
                               :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Fornecedor:</label>
                <Multiselect label="name" v-model="formData.client_employee_provider_id" :options="selectProviderList"
                             :searchable="true"
                             :noOptionsText="noOptionsText"
                             :noResultsText="noResultsText"/>
            </row-col-component>

            <row-col-component v-else :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Cliente:</label>
                <Multiselect label="name" v-model="formData.client_employee_provider_id" :options="selectClientList"
                             :searchable="true"
                             :noOptionsText="noOptionsText"
                             :noResultsText="noResultsText"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-4'">
                <button-submit @submit="submit" :items="buttonSubmit" class="me-2"/>
                <button-route v-if="buttonCheck.create" :items="buttonRoute"/>
            </row-col-component>
        </row-component>

        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col" style="width: 5%">Código</th>
                <th scope="col" style="width: 10%">Criador</th>
                <th scope="col" style="width: 15%">Titulo</th>
                <th scope="col" style="width: 5%">Preço</th>
                <th scope="col" style="width: 15%">Nome</th>
                <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.delete">
                    Ações
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(receipt, index) in object.data" :key="index">
                <td data-label="Código">{{ receipt.code }}</td>
                <td data-label="Criador">
                    <img v-if="receipt.photo_creator" class="avatar__image mx-1" :src="receipt.photo_creator" alt="">
                    <img v-else class="avatar__image mx-1" src="@/assets/images/avatar.png" alt="">
                    {{ receipt.creator_user_name }}
                </td>
                <td data-label="Titulo">{{ receipt.title }}</td>
                <td data-label="Preço">{{ receipt.price }}</td>
                <td data-label="Preço">{{ receipt.name }}</td>
                <td data-label="Ações" v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.delete">
                    <button-edit v-if="buttonCheck.edit" :route="'receipt-edit'" :id-param="receipt.id"/>
                    <button-show v-if="buttonCheck.show" :route="'receipt-show'" :id-param="receipt.id"/>
                    <button-delete v-if="buttonCheck.delete" @delete="destroyReceipt(receipt)"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="receipt.itens" :offset="3" @paginate="loadReceipts"/>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonShow from '@/components/buttons/ButtonShow';
import {useToast} from "vue-toastification";
import ButtonPagination from "@/components/buttons/ButtonPagination.vue";
import swal from "sweetalert";
import ButtonDelete from "@/components/buttons/ButtonDelete.vue";

const toast = useToast()

export default {
    name: 'ReceiptSearch',

    created() {
        this.$store.dispatch('updateNamePage', 'Recibo')
        this.$store.dispatch('loadClientMultiSelect')
        this.$store.dispatch('loadProviderMultiSelect')
        this.$store.dispatch('loadEmployeeMultiSelect')
        this.checkACL()
        this.loadReceipts(1)
    },

    components: {
        ButtonDelete,
        ButtonPagination,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonSubmit,
        ButtonRoute,
        ButtonEdit,
        ButtonShow
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "ti-list"
            },

            buttonSubmit: {
                icon: 'ti-search',
            },

            buttonRoute: {
                icon: 'ti-plus',
                route: '/receipt/create'
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false,
                delete: false
            },

            object: {},

            formData: {
                title: '',
                code: '',
                client_employee_provider_id: '',
                client_employee_provider_type: 2,
            },

            searchSubmit: false,
        }
    },

    methods: {

        submit() {
            this.loadReceipts(1)
            this.searchSubmit = true
        },

        statusString(value) {
            if (value === '1')
                return 'Ativo'
            return 'Inativo'
        },

        loadReceipts(page) {
            if (!this.searchSubmit) {
                this.$store.dispatch('loadReceipts', {...this.params, page})
                    .then((r) => {
                        this.object = r.itens
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.itens.data == '') {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 2000});
                            }
                        }
                    }).catch(() => {
                    this.searchSubmit = false;
                });
            }
        },

        destroyReceipt(item) {
            swal({
                title: 'Atenção!',
                text: `Deseja realmente deletar ${item.name}, ${this.me.name} ?`,
                closeOnClickOutside: false,
                buttons: {
                    cancel: {
                        text: 'Não',
                        visible: true,
                        closeModal: true,

                    },
                    confirm: "Sim"
                }
            }).then((result) => {
                if (result) {
                    this.$store.dispatch('destroyReceipt', item.id).then(() => {
                        this.loadUsers(1)
                        toast.success('Cadastro deletado com sucesso', {timeout: 2000});
                    })
                        .catch(() => {
                            toast.error(`Não foi possivel deletar  ${item.name} `, {timeout: 2000});
                        })
                }
            });
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 18)
                .then((r) => {
                    if (r.data.indexOf('receipt-search') !== -1) {

                        if (r.data.indexOf('receipt-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('receipt-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('receipt-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('receipt-delete') !== -1) {
                            this.buttonCheck.delete = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        selectClientList() {
            return this.$store.state.var.selectClientList
        },

        selectProviderList() {
            return this.$store.state.var.selectProviderList
        },

        selectEmployeeList() {
            return this.$store.state.var.selectEmployeeList
        },

        receipt() {
            return this.$store.state.receipt.items
        },

        params() {
            return {
                page: this.receipt.current_page,
                title: this.formData.title,
                code: this.formData.code,
                client_employee_provider_id: this.formData.client_employee_provider_id,
                client_employee_provider_type: this.formData.client_employee_provider_type,
            }
        },

        me() {
            return this.$store.state.auth.me
        },

    }
}
</script>

<style src="@/assets/style/table.css">

</style>

<style scoped>
.avatar__image {
    width: 30px;
}
</style>
